import { useEffect, useMemo, useState } from 'react'
import { capitalize } from 'lodash'
import { Box, Stack } from '@mui/material'
import { Field, Logger, Typography } from '@wolfdanepug/common-react'
import { SegmentComponentProps } from '../types'
import { ageContextOptions, genderOptions } from '../context/onboarding/options'

export default function Basics({ data, setCanStepForward }: SegmentComponentProps) {
	useEffect(() => {
		Logger.log('[Basics] data', data)
	}, [data])

	// the dog object
	const dog = useMemo(() => {
		const key = data?.dogs?.[data.activeDogContext]
		if (!key) return undefined
		const dogData = data?.dog[key]
		return dogData
	}, [data])

	// the dog gender
	const [gender, setGender] = useState<string>(dog?.gender || undefined)
	// the dog age
	const [age, setAge] = useState<number | undefined>(dog?.age || undefined)
	const [ageContext, setAgeContext] = useState<string>(dog?.ageContext || undefined)

	useEffect(() => {
		gender && age && ageContext && setCanStepForward(true)
	}, [gender, age, ageContext])

	return (
		<Stack gap={3} alignItems="center">
			<Typography variant="h2" textAlign={'center'}>
				{capitalize(dog?.name)}
			</Typography>
			<Stack
				direction={{
					xs: 'column',
					md: 'row'
				}}
				alignItems="center"
				gap={2}
			>
				<Stack direction="row" alignItems="center" gap={2}>
					<Field
						name={['gender', 'dog']}
						type="select"
						variant="standard"
						value={gender}
						options={[
							{
								header: 'Gender'
							},
							...genderOptions
						]}
						onChange={({ target }: any) => setGender(target.value)}
					/>
					<Box>is</Box>
					<Field
						required
						type="number"
						name={['age', 'dog']}
						variant="standard"
						value={age}
						placeholder="Age"
						onChange={({ target }: any) => setAge(target.value)}
						sx={{ field: { '& input': { minWidth: 50, textAlign: 'center' } } }}
					/>
				</Stack>
				<Stack direction="row" alignItems="center" gap={2}>
					<Field
						name={['ageContext', 'dog']}
						type="select"
						variant="standard"
						fullWidth
						value={dog?.ageContext || undefined}
						onChange={({ target }: any) => setAgeContext(target.value)}
						options={[
							{
								header: 'Select'
							},
							...ageContextOptions
						]}
						sx={{ field: { minWidth: 70 } }}
					/>
					<Box>old</Box>
				</Stack>
			</Stack>
		</Stack>
	)
}
